export default __webpack_public_path__ + "static/media/img_x.4e5f9519.svg";